/**
 * @(#)2019/02/18.
 * YxAction，行为组件，收起功能
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./pack.less";
import React from "react";
import defaultProps from "./param";
import { cloneDeep } from "lodash";
import { Menu, Dropdown } from "antd";
import BaseAction from "../BaseAction";
import { showComponent } from "../../YxComponent/tools";
import { l } from "../../../config/language";
import { typeList, unifiedFields } from "../tools";
import { get, merge, random, toArray } from "../../../utils";
import { YxComponent, Route, Connection } from "../../YxComponent";

const MenuItem = Menu.Item;

/**
 * @param {Array} packUpList 收起的按钮
 * @param {Object} packUpList[x].menuItemParam 每个元素项的 MenuItem 参数
 *
 * @param {Object} overlayParam 对应antd 的Dropdown的参数
 *
 * @class PackUpAction
 * @extends {YxComponent}
 */
@Connection(defaultProps)
class PackUpAction extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.divClassName = ["yx_actions_packUp"];
    this.state = {
      visible: false,
    };
  }

  onVisibleChange = (visible) => {
    this.setState({ visible });
  };

  mainItemParam = () => {
    const mainItemParam = get(this.props, "mainItemParam", {});
    const packUpList = get(this.props, "packUpList", []);
    const mainFormList = packUpList.find((item) => item.main);
    if (mainItemParam instanceof Function) {
      return mainItemParam(get(this.props, "data", null));
    } else if (mainFormList != null) {
      return <BaseAction {...mainFormList} />;
    }
    return mainItemParam;
  };

  /**
   * 主按钮默认的参数
   *
   * @memberof PackUpAction
   */
  mainItemDefault = () => {
    const baseParam = this.mainItemParam();
    const styleType = get(baseParam, "styleType", null);
    if (styleType === "icon") {
      return { type: "icongengduo", iconfont: true, ...baseParam };
    }
    return baseParam;
  };

  mainStyle = () => {
    const packUpType = get(this.props, "packUpType", null);
    if (packUpType == null) {
      const packUpList = get(this.props, "packUpList", []);
      const result = unifiedFields(packUpList, "styleType", "link");
      return result;
    }
    return packUpType;
  };

  static typeList = typeList;

  renderItem = (item, packUpType, index) => {
    const baseParam = merge({ styleParam: { size: "sm" } }, item);
    const param = {
      ...baseParam,
      packtype: packUpType,
      styleType: packUpType === "icon" ? "icon" : "link",
    };
    const disabled = get(param, "disabled", false);
    const menuItemParam = merge({ disabled }, get(item, "menuItemParam", {}));
    const Action = <BaseAction key={index} {...param} />;
    const show = showComponent(param);
    const DOM = (
      <MenuItem key={index} {...menuItemParam}>
        {Action}
      </MenuItem>
    );
    return { DOM, show };
  };

  overlay = (packUpType) => {
    const packUpList = get(this.props, "packUpList", []);
    const packUpDicts = packUpList.map((item, index) =>
      this.renderItem(item, packUpType, index)
    );
    const list = packUpDicts.filter((i) => i.show === true);
    if (list.length === 0) {
      return null;
    }
    return <Menu children={list.map((l) => l.DOM)} />;
  };

  mainItem = (packUpType) => {
    const param = {
      styleType: packUpType,
      iconfont: true,
      dropdown: this.state.visible + "",
    };
    if (packUpType === "link") {
      param.text = l("YxAction.plm", this);
      param.icon = "iconxialazhanshi";
    } else if (packUpType === "icon") {
      param.type = "icongengduo";
    } else if (packUpType === "button") {
      param.text = l("YxAction.pbm", this);
      param.type = "primary";
      param.dropDown = true;
    }
    const mainItemParam = this.mainItemDefault();
    return <BaseAction {...merge(param, mainItemParam)} />;
  };

  dropdownParam = (packUpType) => {
    const dropdownParam = get(this.props, "overlayParam", {});
    const className = get(dropdownParam, ["className", "overlayClassName"], "");
    const classList = [
      className,
      `yx_actions_packUp_${packUpType}`,
      "yx_actions_packUp",
    ];
    const param = {
      ...dropdownParam,
      onVisibleChange: this.onVisibleChange,
      overlayClassName: classList.join(" "),
    };
    return param;
  };

  render() {
    const packUpType = this.mainStyle();
    const mainItem = this.mainItem(packUpType);
    const overlay = this.overlay(packUpType);
    if (overlay == null) {
      return null;
    } else {
      return (
        <Dropdown {...this.dropdownParam(packUpType)} overlay={overlay}>
          {mainItem}
        </Dropdown>
      );
    }
  }
}

export default PackUpAction;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/PackUpAction/index.js